import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'

const ItemConfirmModal = ({
  open,
  title = 'Tem certeza?',
  description = '',
  confirmationText = 'Confirmar',
  cancellationText = 'Cancelar',
  handleOpen = () => {},
  onConfirm = () => {},
}) => {
  const classes = filterStylesComponents()

  const handleConfirm = () => {
    onConfirm()
    handleOpen()
  }

  return (
    <BaseFilterModal
      open={open}
      title={title}
      hiddenHelpButton
      handleOpen={handleOpen}
    >
      <Grid item xs={12} style={{ width: '260px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ color: colors.textGray }}>
              {description}
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              type="button"
              onClick={handleOpen}
              className={classes.btnMoreFilters}
            >
              {cancellationText}
            </Button>

            <Button
              type="button"
              onClick={handleConfirm}
              className={classes.btnAdd}
            >
              {confirmationText}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default ItemConfirmModal
